import axios from 'axios'

import { API_BASE_URL } from 'utils/consts.mjs'

export interface UpdatePaymentParams {
  tokenId: string
  threeDSecureToken?: string
  method?: string
}

export const updateUserPaymentMethod = ({
  tokenId,
  threeDSecureToken = undefined,
  method = 'put',
}: UpdatePaymentParams) => {
  return axios({
    withCredentials: true,
    method,
    baseURL: API_BASE_URL,
    url: '/user/payment_method',
    data: {
      tokenId,
      threeDSecureToken,
    },
  })
}
